/** Authenticated product home (post–sign-in default). */
export const AUTHENTICATED_HOME_PATH = "/events" as const

/**
 * Past events list + archive detail entry.
 * Route path remains `/timeline` for deep links and API compatibility — IA label is “Archive”.
 */
export const AUTHENTICATED_ARCHIVE_PATH = "/timeline" as const

/** Public marketing entry. */
export const PUBLIC_LANDING_PATH = "/" as const

export const PUBLIC_DEMO_ENTRY_PATH = "/demo" as const

/*
 * IA follow-ups (proposal-only — not product commitments):
 * - Anniversary resurfacing for past events in Archive
 * - Collaborative memory prompts tied to hosts/guests
 * - Archive exports / year-in-review summaries
 * - Upload-window reminders when memory collection closes soon (wire only if server already exposes dates)
 */
